import { useState } from "react";

const useHover = () => {
  const [isHovering, setIsHovered] = useState(false);
  const onMouseEnter = () => setIsHovered(true);
  const onMouseLeave = () => setIsHovered(false);

  return {
    isHovering,
    onMouseEnter,
    onMouseLeave,
  };
};

export default useHover;
